import React from 'react';
import { Box, Typography } from '@mui/material';

const CardPreviewModal = ({ card, position, onClose }) => {
    if (!card) {
        return null;
    }

    // Calculate optimal position to keep preview on screen
    const previewWidth = 400;
    const previewHeight = 400;
    const offset = 200;

    let left = position.x - offset;
    let top = position.y - offset;

    // Ensure preview doesn't go off the right edge
    if (left + previewWidth > window.innerWidth) {
        left = position.x - previewWidth - 20; // 20px margin
    }

    // Ensure preview doesn't go off the left edge
    if (left < 0) {
        left = 20; // 20px margin
    }

    // Ensure preview doesn't go off the bottom edge
    if (top + previewHeight > window.innerHeight) {
        top = position.y - previewHeight - 20; // 20px margin
    }

    // Ensure preview doesn't go off the top edge
    if (top < 0) {
        top = 20; // 20px margin
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                top: top,
                left: left,
                width: 'auto',
                height: 'auto',
                maxWidth: previewWidth,
                maxHeight: previewHeight,
                zIndex: 9999,
                pointerEvents: 'none'
            }}
        >
            <Box
                sx={{
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.8)',
                    border: '2px solid rgba(76, 29, 149, 0.5)',
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                    backdropFilter: 'blur(10px)'
                }}
            >
                {card.image_urls && card.image_urls.length > 0 ? (
                    <img
                        src={card.image_urls[0].url}
                        alt={card.name}
                        style={{
                            display: 'block',
                            maxWidth: previewWidth,
                            maxHeight: previewHeight,
                            width: 'auto',
                            height: 'auto',
                            objectFit: 'contain'
                        }}
                    />
                ) : (
                    <Box
                        sx={{
                            width: '300px',
                            height: '400px',
                            background: 'linear-gradient(135deg, rgba(76, 29, 149, 0.2), rgba(139, 92, 246, 0.2))',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '2px dashed rgba(76, 29, 149, 0.3)'
                        }}
                    >
                        <Typography variant="h6" color="text.secondary">
                            No image
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default CardPreviewModal; 